import React from "react";
import store from ".";
import { Provider } from "react-redux";
import createNamespace from "services/language";
import { SettingsProvider } from "modules/gameSettings/hook";

const Namespace = createNamespace({
  Component: ({ children }) => children,
});

export default ({ element }) => {
  return (
    <Provider store={store}>
      <SettingsProvider>
        <Namespace>{element}</Namespace>
      </SettingsProvider>
    </Provider>
  );
};
